export class BankMaster {
    public BANK_ID!: number;
    public BANK_CODE!: string;
    public BANK_NAME!: string;
    public IS_ACTIVE!: number;
    public LEDGER_NAME!: string;
    public OPENING_AMT!: number;
}